__turbopack_context__.v({
  "affiliate_bold": "ff-partners-module-scss-module__CaJA9G__affiliate_bold",
  "affiliate_contact": "ff-partners-module-scss-module__CaJA9G__affiliate_contact",
  "ani_open_img": "ff-partners-module-scss-module__CaJA9G__ani_open_img",
  "ani_translateY": "ff-partners-module-scss-module__CaJA9G__ani_translateY",
  "caution_text": "ff-partners-module-scss-module__CaJA9G__caution_text",
  "contact-box": "ff-partners-module-scss-module__CaJA9G__contact-box",
  "contact_header": "ff-partners-module-scss-module__CaJA9G__contact_header",
  "ff_partners_flow_root": "ff-partners-module-scss-module__CaJA9G__ff_partners_flow_root",
  "form-box": "ff-partners-module-scss-module__CaJA9G__form-box",
  "img_area": "ff-partners-module-scss-module__CaJA9G__img_area",
  "inner": "ff-partners-module-scss-module__CaJA9G__inner",
  "lead_form": "ff-partners-module-scss-module__CaJA9G__lead_form",
  "lead_form_actions": "ff-partners-module-scss-module__CaJA9G__lead_form_actions",
  "leadforms_box": "ff-partners-module-scss-module__CaJA9G__leadforms_box",
  "text_box": "ff-partners-module-scss-module__CaJA9G__text_box",
  "text_p1": "ff-partners-module-scss-module__CaJA9G__text_p1",
  "title_h1": "ff-partners-module-scss-module__CaJA9G__title_h1",
  "welcome_contact": "ff-partners-module-scss-module__CaJA9G__welcome_contact",
});
